const INITIAL_STATE = {
  data: {},
  addUser: {},
  deleteUser: {},
  errors: {},
}

const getBlockList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'BLOCK_LIST':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'BLOCK_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_BLOCK_USER':
    return { ...state, ...INITIAL_STATE, addUser: action.data }
  case 'ADD_BLOCK_USER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'DELETE_BLOCK_USER':
    return { ...state, ...INITIAL_STATE, deleteUser: action.data }
  case 'DELETE_BLOCK_USER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default getBlockList;
